module.exports = window;


//////////////////
// WEBPACK FOOTER
// external "window"
// module id = 2
// module chunks = 1